import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'seagull';
import styles from './PresetButton.module.scss';
const PresetButton = (param)=>{
    let { onClick, disabled, testId, label, biName } = param;
    return /*#__PURE__*/ _jsx(Button, {
        bi: {
            name: biName
        },
        skin: "primaryOutline",
        onClick: onClick,
        disabled: disabled,
        testId: testId,
        className: styles.presetButton,
        children: label
    });
};
export default PresetButton;
